/**
 * Default Employee role permissions — keep in sync with
 * donequick-hr-backend/config/role_permission_templates.php (Employee key).
 */
export const EMPLOYEE_ROLE_NAME = "Employee";

export const EMPLOYEE_ROLE_TEMPLATE_PERMISSIONS = [
  "Attendance.Read",
  "TimingSheets.Read",
  "TimingSheets.Create",
  "TimingSheets.Edit",
  "TimingSheets.Delete",
  "Leaves.Read",
  "Leaves.Create",
];

const FALLBACK_MODULE_LABELS = {
  Attendance: "Attendance",
  TimingSheets: "Timesheets",
  Leaves: "Leaves",
};

const FALLBACK_ACTION_LABELS = {
  Read: "View",
  Create: "Create",
  Edit: "Edit",
  Delete: "Delete",
};

/**
 * @param {{ modules?: Array<{key:string,label?:string}>, actions?: Array<{key:string,label?:string}>, normalizePermissionName?: (p:string)=>string } | null | undefined} catalog
 * @returns {Array<{ module: string, moduleLabel: string, actions: Array<{ key: string, label: string }> }>}
 */
export function groupEmployeeRoleDefaults(catalog) {
  const moduleLabel = (key) => {
    const mod = catalog?.modules?.find((m) => m.key === key);
    return mod?.label || FALLBACK_MODULE_LABELS[key] || key;
  };

  const actionLabel = (key) => {
    const act = catalog?.actions?.find((a) => a.key === key);
    return act?.label || FALLBACK_ACTION_LABELS[key] || key;
  };

  const normalize =
    typeof catalog?.normalizePermissionName === "function"
      ? catalog.normalizePermissionName.bind(catalog)
      : (p) => p;

  const grouped = new Map();

  for (const raw of EMPLOYEE_ROLE_TEMPLATE_PERMISSIONS) {
    const name = normalize(raw);
    if (!name.includes(".")) continue;

    const [module, action] = name.split(".", 2);
    if (!grouped.has(module)) {
      grouped.set(module, {
        module,
        moduleLabel: moduleLabel(module),
        actions: [],
      });
    }

    grouped.get(module).actions.push({
      key: action,
      label: actionLabel(action),
    });
  }

  return Array.from(grouped.values());
}
